// react-router-domのインポートを追加
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useLayoutEffect } from "react";
import Data from './data/works.json';
import { Header } from "./components/Header";
import { MobileHeader } from "./components/MobileHeader";
import { Home } from "./components/Home";
import { Works } from "./components/Works";
import { Publication } from "./components/Publication";
import { Contact } from "./components/Contact";
import { WorkTemplate } from "./components/WorkTemplate";
import { ScrollToTop } from "./ScrollToTop";
import { getUa } from "./libs/Utils";


function App() {
  const [lang, setLang] = useState("jp");
  const [ua, setUa] = useState("pc");
  const [scrollTop, setScrollTop] = useState(0);
  const [openMenu, setOpenMenu] = useState(false);

  //const [contentList, setContentList] = useState([]);

  window.onscroll = () => {
    setScrollTop(Math.max(document.body.scrollTop, document.documentElement.scrollTop));
  }

  useLayoutEffect(() => {
    setUa(getUa());
  }, []);

  const changeLang = (l) => {
    setLang(l);
  }

  const changeOpenMenu = (phase) => {
    setOpenMenu(phase);
  }

  /*
useEffect(() => {

  const iList = getLists().map((l) => {
    var i = new Image();
    i.src = "/works/" + l.id + "/" + l.thumbnail;
    return i;
  });
  setContentList(iList);
}, []);
*/

  const getLists = () => {
    const researchList = Data.jp.research.map((w, i) => {
      return (w.contents.filter((ww, i) => {
        return (ww.outerLink === undefined);
      }).map((ww, i) => { return ({ id: ww.id, thumbnail: (ww.thumbnail === undefined ? "top.jpg" : ww.thumbnail) }); })
      )
    }).flat();
    const productList = Data.jp.product.filter((ww, i) => {
      return (ww.outerLink === undefined);
    }).map((p) => { return ({ id: p.id, thumbnail: (p.thumbnail === undefined ? "top.jpg" : p.thumbnail) }) });
    const cList = [researchList, productList].flat();
    return cList;
  }

  const createLinks = () => {
    const cList = getLists().map((l) => l.id);
    return (
      cList.map((c, i) => <Route key={"r_" + i} path={'/works/' + c} element={<WorkTemplate lang={lang} id={c} ua={ua} />} />)
    );
  }


  return (
    <BrowserRouter>
      <div className="App" >

        {ua === "pc" ? <Header lang={lang} changeLang={changeLang} /> : <MobileHeader lang={lang} changeLang={changeLang} scrollTop={scrollTop} openMenu={openMenu} changeOpenMenu={changeOpenMenu} />}

        <div className="wrapper main">
          <ScrollToTop />
          <Routes>
            {/* exactをつけると完全一致になります。Homeはexactをつけてあげます */}
            <Route path='/' element={<Home lang={lang} ua={ua} />} />
            <Route path='/home' element={<Home lang={lang} ua={ua} />} />
            <Route path='/works' element={<Works lang={lang} ua={ua} />} />
            <Route path='/publication' element={<Publication lang={lang} ua={ua} />} />
            <Route path='/contact' element={<Contact lang={lang} ua={ua} />} />
            {createLinks()}
          </Routes>
        </div>
      </div>

      <div id="footer">
        <div>
          <p>
            <span className="copy"> © Yuki Ban</span>
          </p>
          <p className="copy">Last update: 2025-3-20</p>
        </div>
      </div>
    </BrowserRouter >
  );
}

export default App;